import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "list"]

  connect() {
    console.log("✅ add_user_controller conectado")
  }

  addUser(event) {
    event.preventDefault()
    console.log("➕ Añadiendo nuevo usuario")
    if (this.hasTemplateTarget && this.hasListTarget) {
      const content = this.templateTarget.content.cloneNode(true)
      this.listTarget.prepend(content)
    } else {
      console.warn("⚠️ No se encontraron los targets 'template' o 'list'.")
    }
  }
}
